<template>
  <div class="rewards" v-if="rewards">
    <div class="rewards__shelf" v-if="trophies.length">
      <span v-for="(reward, i) in trophies" :key="i">
        <Trophy :reward="reward" />
      </span>
    </div>

    <div class="rewards__shelf" v-if="medals.length">
      <span v-for="(reward, i) in medals" :key="i">
        <Trophy :reward="reward" />
      </span>
    </div>

    <div class="rewards__shelf" v-if="participations.length">
      <span v-for="(reward, i) in participations" :key="i">
        <Trophy :reward="reward" />
      </span>
    </div>
  </div>
</template>

<script>
import Trophy from "./Trophy.vue";
import { REWARD } from "../../constants";

export default {
  components: { Trophy },

  name: "PlayerTrophies",

  props: ["rewards"],

  computed: {
    trophies() {
      return this.rewards
        .filter((r) => r.reward.startsWith(REWARD.TROPHY))
        .sort((a, b) =>
          a.reward > b.reward ? 1 : a.reward < b.reward ? -1 : 0
        );
    },

    medals() {
      return this.rewards
        .filter((r) => r.reward.startsWith(REWARD.MEDAL))
        .sort((a, b) =>
          a.reward > b.reward ? 1 : a.reward < b.reward ? -1 : 0
        );
    },

    participations() {
      return this.rewards.filter((r) =>
        r.reward.startsWith(REWARD.PARTICIPATION)
      );
    },
  },
};
</script>

<style scoped>
.rewards__shelf {
  min-width: 150px;
  margin: 10px 0;
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(20px, 1fr));
}
</style>
